import { useMutation } from '@tanstack/react-query';
import { queryClient, QUERY_KEYS } from '@src/query';
import { ApiError } from '@src/services/api';
import { deleteCreator } from './api';

export const useMutationDeleteCreator = () =>
  useMutation<
    boolean,
    ApiError,
    {
      id: string;
    }
  >({
    mutationFn: ({ id }) => deleteCreator(id),
    onSuccess: async () => {
      let key = QUERY_KEYS.influencers();
      queryClient.invalidateQueries({ queryKey: key });
      queryClient.refetchQueries({ queryKey: key });

      key = QUERY_KEYS.blacklistedCreators();
      queryClient.invalidateQueries({ queryKey: key });
      queryClient.refetchQueries({ queryKey: key });
    },
  });
